import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
    selector: 'usimweb-select',
    template: `
    <mat-form-field [style.width.%]="fullWidth ? 100 : null">
      <mat-label *ngIf="label">{{ label }}</mat-label>
      <mat-select
        [(ngModel)]="default"
        [placeholder]="placeholder"
        (ngModelChange)="valueChange.emit($event)"
        (selectionChange)="selectionChange.emit($event)"
        [disabled]="disabled"
      >
        <mat-option *ngIf="empty" value="">-</mat-option>
        <mat-option *ngFor="let option of options" [value]="option.key">{{ option.value }}</mat-option>
      </mat-select>
    </mat-form-field>
  `,
    standalone: false
})
export class SelectComponent {
  @Input() label!: string;
  @Input() options!: any[];
  @Input() default: any;
  @Input() empty: boolean = false;
  @Input() placeholder!: string;
  @Input() fullWidth: boolean = false;
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<MatSelectChange>();
}
